<script setup>
import ImgMedia from '@/Components/Images/ImgMedia.vue';
import envelope from '@i/envelope.svg';
import phoneIcon from '@i/phone.svg';
import Icon from '@/Components/Icon.vue';
import Model from '@/Components/Blocks/Team/Modal.vue';
import imageIcon from '@i/image.svg';
import { ref } from 'vue';

defineProps({
    member: Object,
});

const showModal = ref(false);
</script>

<template>
    <button
        class="relative h-full"
        @click="showModal = true"
    >
        <div class="relative overflow-hidden rounded-t-xl">
            <div v-if="member.image">
                <ImgMedia
                    :classes="'min-h-[155px] sm:min-h-[250px] md:min-h-[400px] 2xl:min-h-[300px] object-cover h-[155px] w-full rounded-tl-xl rounded-tr-xl  transition-transform duration-300'"
                    :media="member.image"
                />
            </div>
            <div
                v-else
                class="flex min-h-[155px] w-full items-center justify-center rounded-t-xl bg-gray-light sm:min-h-[250px] md:min-h-[400px] 2xl:min-h-[300px]"
            >
                <img
                    :src="imageIcon"
                    alt="icon"
                    class="h-4 w-4 opacity-10 md:h-10 md:w-10"
                >
            </div>
        </div>

        <div class="flex flex-col  p-6">
            <span
                v-if="member.name"
                class="mb-3 text-left text-gray-medium md:px-4"
            > {{ member.name }}
            </span>


            <div class="md:px-4">
                <div>
                    <div v-if="member.phone">
                        <div class="flex items-center gap-2">
                            <Icon
                                :icon="phoneIcon"
                                :icon-dutch="phoneIcon"
                                alt="phone icon"
                                class="h-auto w-4 shrink-0"
                            />
                            <a
                                :href="`tel:${member.phone}`"
                                class="hover:text-primary"
                            >{{ member.phone }}</a>
                        </div>
                    </div>

                    <div v-if="member.email">
                        <div class="flex items-center gap-2">
                            <Icon
                                :icon="envelope"
                                :icon-dutch="envelope"
                                alt="envelope icon"
                                class="h-auto w-5 shrink-0"
                            />
                            <a
                                :href="`mailto:${member.email}`"
                                class="hover:text-primary"
                            >{{ member.email }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </button>
    <Model
        v-model="showModal"
        :member="member"
    />
</template>
